import { render, staticRenderFns } from "./ThirdCur.vue?vue&type=template&id=72fc7ba3&scoped=true&"
import script from "./ThirdCur.vue?vue&type=script&lang=js&"
export * from "./ThirdCur.vue?vue&type=script&lang=js&"
import style0 from "./ThirdCur.vue?vue&type=style&index=0&id=72fc7ba3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc7ba3",
  null
  
)

export default component.exports